
Drupal.behaviors.hamburger = {
  attach: function (context, settings) {
    once('armed', '.tham', context).forEach(el => {
      el.addEventListener('click', () => {
        el.classList.toggle('tham-active');
      });
    });
  },
};
